var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarTbc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6 1.31646H11.1C11.58 1.31646 12 1.73401 12 2.2112V10.5621C12 11.0393 11.58 11.4568 11.1 11.4568H0.9C0.42 11.4568 0 11.0393 0 10.5621V2.2112C0 1.73401 0.42 1.31646 0.9 1.31646H2.4V1.01822C2.4 0.839269 2.52 0.719971 2.7 0.719971C2.88 0.719971 3 0.839269 3 1.01822V1.31646H5.7V1.01822C5.7 0.839269 5.82 0.719971 6 0.719971C6.18 0.719971 6.3 0.839269 6.3 1.01822V1.31646H9V1.01822C9 0.839269 9.12 0.719971 9.3 0.719971C9.48 0.719971 9.6 0.839269 9.6 1.01822V1.31646ZM0.6 3.56208V2.21106C0.6 2.03211 0.72 1.91282 0.9 1.91282H2.4V2.80755C2.4 2.9865 2.52 3.1058 2.7 3.1058C2.88 3.1058 3 2.9865 3 2.80755V1.91282H5.7V2.80755C5.7 2.9865 5.82 3.1058 6 3.1058C6.18 3.1058 6.3 2.9865 6.3 2.80755V1.91282H9V2.80755C9 2.9865 9.12 3.1058 9.3 3.1058C9.48 3.1058 9.6 2.9865 9.6 2.80755V1.91282H11.1C11.28 1.91282 11.4 2.03211 11.4 2.21106V3.56208V3.70229V10.4951C11.4 10.6932 11.28 10.8252 11.1 10.8252H0.9C0.72 10.8252 0.6 10.6932 0.6 10.4951V3.70229V3.56208ZM5.24211 4.93266L5.46947 7.50713H6.53053L6.75789 4.93266L6.81474 3.56208H5.18526L5.24211 4.93266ZM5.05263 8.91475C5.05263 9.45187 5.45053 9.87787 6 9.87787C6.54947 9.87787 6.94737 9.45187 6.94737 8.91475C6.94737 8.37764 6.54947 7.95164 6 7.95164C5.45053 7.95164 5.05263 8.37764 5.05263 8.91475Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTbc);
export default __webpack_public_path__ + "static/media/calendar-tbc.6efe74e1088f7d1a0a4ce29ba7432e41.svg";
export { ForwardRef as ReactComponent };